import ComponentModule from "@eisinc/Overrides/Components/ProductShareLink";

export * from "@eisinc/Overrides/Components/ProductShareLink";

export default ComponentModule;
